import ProjectAnalysisPage from "@features/analysis/components/ProjectAnalysisPage/ProjectAnalysisPage";
import ProjectsDashboardPage from "@features/dashboard/components/DashboardPage/DashboardPage";
import ProjectPage from "@features/project/components/ProjectPage/ProjectPage";
import useAppStore from "@hooks/useAppStore";
import i18n from "@i18n/i18n";
import { useTheme } from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BreadcrumbData, getBreadcrumbs } from "use-react-router-breadcrumbs";

const ProjectNameBreadcrumb = observer(() => {
  const appStore = useAppStore();
  //console.log("ProjectNameBreadcrumb: ", appStore.project);

  return <span>{appStore.project?.name}</span>;
});

const Breadcrumbs = observer(() => {
  //console.log("Breadcrumbs");

  const routes = [
    {
      path: "/projects",
      element: <ProjectsDashboardPage />,
      breadcrumb: i18n.t("breadcrumbs.title.projects"),
      children: [
        {
          path: "/projects/:id",
          element: <ProjectPage />,
          breadcrumb: ProjectNameBreadcrumb,
          children: [
            {
              path: "/projects/:id/analysis",
              element: <ProjectAnalysisPage />,
              breadcrumb: i18n.t("breadcrumbs.title.analysis"),
            },
          ],
        },
      ],
    },
  ];

  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const breadcrumbs = getBreadcrumbs({ routes, location, options: { excludePaths: ["/"] } });
  const [activeTab, setActiveTab] = useState<number>(0);
  //console.log("breadcrumbs: ", breadcrumbs);

  const checkNavigation = (_event: any, indexSelected: any) => {
    //console.log("breadcrumbs ${indexSelected}:", breadcrumbs[indexSelected]);

    const pathname = breadcrumbs[indexSelected].key;
    setActiveTab(indexSelected);
    navigate(pathname);
  };

  useEffect(() => {
    const index = breadcrumbs.findIndex((breadcrumb: BreadcrumbData) => location.pathname === breadcrumb.match.pathname);
    if (index !== -1) {
      console.log("Breadcrumbs - setting active tab to index: ", index, breadcrumbs);
      setActiveTab(index);
    }
  }, [location]);

  if (activeTab === -1 || activeTab >= breadcrumbs.length) {
    return null;
  }

  return (
    <Tabs
      value={activeTab}
      onChange={checkNavigation}
      sx={{
        "& .MuiButtonBase-root": {
          maxWidth: "unset",
        },
        "& .MuiButtonBase-root + .MuiButtonBase-root:before": {
          color: theme.palette.text.primary,
          content: '"/"',
          display: "block",
          position: "absolute",
          left: "0px",
        },
        "& .MuiButtonBase-root.Mui-selected": {
          color: theme.palette.text.primary,
        },
        "& .MuiTabs-flexContainer": {
          margin: "0 20px",
        },
        "& .MuiTabs-indicator": {
          display: "none",
        },
      }}
    >
      {breadcrumbs.map(({ breadcrumb }, index) => {
        //console.log("breadcrumb: ", breadcrumb);
        return <Tab key={index} label={breadcrumb} sx={{ position: "relative", padding: "8px 16px" }}></Tab>;
      })}
    </Tabs>
  );
});

export default Breadcrumbs;
